import React, { useEffect, useState } from "react"
import MetaTags from "react-meta-tags"
import { withRouter, Link } from "react-router-dom"
import { connect } from "react-redux"
import {
  Container,
  Row,
  Col,
  Button,
  Card,
  CardBody,
  Label,
  Badge,
  Input,
  Table,
  Spinner,
} from "reactstrap"
import Modal from "react-bootstrap/Modal"
import Select from "react-select"
import { useSelector, useDispatch } from "react-redux"
import PropTypes from "prop-types"
import { ReactSearchAutocomplete } from "react-search-autocomplete"
import { isEmpty } from "lodash"
import moment from "moment"
import ButtonSpinner from "../../components/ButtonSpinner"
//Import Styles
import "./styles.scss"
//Data Table packeages
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  SizePerPageDropdownStandalone,
  PaginationTotalStandalone,
} from "react-bootstrap-table2-paginator"
import ToolkitProvider from "react-bootstrap-table2-toolkit"

//components
import Breadcrumbs from "../../components/Common/Breadcrumb"
import * as eventCancelAction from "../../store/ZXZlbnRDYW5jZWw/actions"
import api from "helpers/Api"

const EventCancel = (props) => {
  const title = "Event Cancelled"
  const { dispatch, searchBarStyle } = props

  useEffect(() => {
    dispatch(eventCancelAction.loadRecordsMetaData())
    dispatch(
      eventCancelAction.loadEventCancelledList({
        page: 1,
        limit: 50,
      })
    )
  }, [])

  //Reducer store state maintenance
  const specificDispatch = useDispatch()

  const eventCancelUpdate = useSelector((state) => state.eventCancel)

  const { recordsMetaData = {}, event_cancelled_details = [] } =
    eventCancelUpdate

  const sessionUpdate = useSelector((specificstate) => specificstate.session)

  const { user = [] } = sessionUpdate

  console.log(user, "user details from session")

  //Date format
  const dateSetting =
    !isEmpty(user) && user.setting && user.setting.dateFormate
      ? user.setting.dateFormate.toUpperCase()
      : []

  const dateFormate = !isEmpty(dateSetting) && dateSetting ? dateSetting : ""

  //manage Ec initial state
  const [eventData, seteventData] = useState({
    company: [],
    branch: [],
    department: [],
    fromDate: "",
    toDate: "",
    leadNo: "",
  })

  //handle change
  const handleChange = async (e) => {
    seteventData({ ...eventData, [e.target.name]: e.target.value })
  }

  //dropdown initial state
  const [companies, setCompanies] = useState([])
  const [branches, setBranches] = useState([])
  const [events, setEvents] = useState([])
  const [salesAgent, setSalesAgent] = useState([])

  const [resetManager, setResetManager] = useState(false)

  //reset functionalities
  const resetForm = () => {
    setCompanies([])
    setBranches([])
    setEvents([])
    setSalesAgent([])
    seteventData({
      fromDate: "",
      toDate: "",
      leadNo: "",
    })
    setResetManager(true)
    setTimeout(() => {
      setResetManager(false)
    }, 0)
    dispatch(
      eventCancelAction.loadEventCancelledList({
        page: pageChange ? pageCount : 1,
        limit: 50,
      })
    )
  }

  //button spinner state
  const [btnLoader, setBtnLoader] = useState(false)
  //dropdown options

  const company =
    !isEmpty(companies) && companies.map((company) => company.value)
  const branch = !isEmpty(branches) && branches.map((branch) => branch.value)
  const branchOptions =
    !isEmpty(recordsMetaData) &&
    recordsMetaData.branchOptions.filter(
      (branch) =>
        branch.companyId ===
        companies.map((company) => company.value).toString()
    )

  //fuse options for venue(autocomplete field)
  const fuseOptions = {
    keys: ["empCode", "label"],
  }

  //Searchvalue
  const [searchValueList, setSearchValueList] = useState({})
  console.log(searchValueList, "searchValueList")

  const [pageCount, setPageCount] = useState("")
  const [pageLoad, setPageLoad] = useState(false)
  const [downloadLoading, setDownloadLoading] = useState(false)
  const [pageChange, setPageChange] = useState(false)
  const searchValue = !isEmpty(searchValueList)
    ? searchValueList
    : {
        page: pageChange ? pageCount : 1,
        limit: 50,
      }
  console.log(searchValue, "searchValue")
  //apply filter submit

  const applyFilter = (e) => {
    e.preventDefault()
    var searchCompany = companies && companies ? company : ""
    var searchBranch = branches && branches ? branch : ""
    var searchEvent = events && events ? events.value : ""
    var searchAgent = salesAgent && salesAgent ? salesAgent.value : ""
    var searchFromDate =
      eventData && eventData.fromDate
        ? moment(eventData.fromDate).format("YYYY-MM-DD")
        : ""
    var searchToDate =
      eventData && eventData.toDate
        ? moment(eventData.toDate).format("YYYY-MM-DD")
        : ""
    var searchLeadNo = eventData && eventData.leadNo ? eventData.leadNo : ""

    var searchvalue = {}
    searchvalue.page = pageChange ? pageCount : 1
    searchvalue.limit = 50
    // searchvalue.isManageEC = true
    if (searchCompany) {
      searchvalue.companyId = searchCompany
    }
    if (searchAgent) {
      searchvalue.employeeId = searchAgent
    }
    if (searchBranch) {
      searchvalue.branchId = searchBranch
    }
    if (searchEvent) {
      searchvalue.eventId = searchEvent
    }
    if (searchFromDate) {
      searchvalue.eventFromDate = searchFromDate
    }
    if (searchToDate) {
      searchvalue.eventToDate = searchToDate
    }
    if (searchLeadNo) {
      searchvalue.leadNo = searchLeadNo
    }
    setSearchValueList(searchvalue)
    specificDispatch(eventCancelAction.loadEventCancelledList(searchvalue))
    setBtnLoader(true)
    setDownloadLoading(true)
    setTimeout(() => {
      setBtnLoader(false)
      setDownloadLoading(false)
    }, 2000)
  }

  //data table for manageEc

  const colorCode = !isEmpty(recordsMetaData)
    ? recordsMetaData.processStatusOptions.filter(
        (status) => status.processStatusId === "PS21"
      )
    : []

  console.log(colorCode, "colorCode")
  console.log(recordsMetaData, "recordsMetaData")

  let slNo = 0
  const eventDataTable = !isEmpty(event_cancelled_details)
    ? event_cancelled_details.data.map((eventData, index) => {
        slNo = slNo + 1

        const cancelledDate = !isEmpty(eventData.eventCancelOn)
          ? moment(eventData.eventCancelOn)
              .subtract(5, "hours")
              .subtract(30, "minutes")
              .format(`${dateFormate} hh:mm A`)
          : "--"

        const eventCount =
          !isEmpty(eventData) && eventData.events.length > 0
            ? eventData.events.length
            : 0

        const colorCode =
          !isEmpty(recordsMetaData) &&
          recordsMetaData.processStatusOptions &&
          recordsMetaData.processStatusOptions.length > 0 &&
          recordsMetaData.processStatusOptions.find(
            (_) => _.processStatusId === eventData.ecProcessStatus
          ) &&
          recordsMetaData.processStatusOptions.find(
            (_) => _.processStatusId === eventData.ecProcessStatus
          )

        return {
          _id: eventData._id,
          sNo: slNo,
          leadNo: eventData.leadNo,
          // leadNo: eventData.leadNo,
          branchName: eventData.branchName,
          groomName: eventData.groomName,
          brideName: eventData.brideName,
          routeData: eventData,
          clientName: !isEmpty(eventData.clientDetails)
            ? eventData.clientDetails.firstName +
              " " +
              eventData.clientDetails.lastName
            : "",
          companyName: eventData.companyName,
          leadServiceName: eventData.leadServiceName,
          leadSourceName: eventData.leadSourceName,
          leadType: eventData.leadType,
          salesUrge: eventData.salesUrge,
          overallStatus: !isEmpty(eventData.overAllStatus)
            ? eventData.overAllStatus
            : "--",
          allowOrder: !isEmpty(eventData.allowOrder)
            ? eventData.allowOrder
            : "--",
          eventDetails: eventData.events,
          clientCode: !isEmpty(eventData.clientDetails)
            ? eventData.clientDetails.clientNo
            : "",
          events: eventCount,
          clientDetails: eventData.clientDetails,
          colorCode: colorCode.colorCode,
          ecStatusName: colorCode.label,
          ecAssign:
            eventData.ecProcessStatus !== "PS2"
              ? eventData.ecPrcessStatusName
              : "--",
          assignedEcName: !isEmpty(eventData.leadECAssign)
            ? eventData.leadECAssign.assignedToName
            : "",
          cancelledDate: cancelledDate,
          eventCancelRemarks: !isEmpty(eventData.eventCancelRemarks)
            ? eventData.eventCancelRemarks
            : "--",
          eventCancelByName: !isEmpty(eventData.eventCancelByName)
            ? eventData.eventCancelByName
            : "--",
          eventCancelattachment: !isEmpty(eventData.eventCancelattachment)
            ? eventData.eventCancelattachment
            : "",
          ecProcessStatus: eventData.ecProcessStatus,
          ecProcessStatusName: eventData.ecPrcessStatusName,
          clearanceReport:
            eventData.ecProcessStatus !== "PS2"
              ? eventData.ecPrcessStatusName
              : "--",
          clearanceStatus: (
            <Badge
              color={
                eventData.ecProcessStatus === "PS21" ? "success" : "danger"
              }
              style={{ padding: "6px" }}
            >
              Clearance
            </Badge>
          ),
          leadStatus: (
            <Badge
              color={
                eventData.leadAssign.leadStatus === "PS2" ? "success" : "danger"
              }
              style={{ padding: "6px" }}
            >
              {" "}
              {!isEmpty(eventData) && eventData.leadAssign.leadStatus === "PS2"
                ? "Assigned"
                : "Unassigned"}
            </Badge>
          ),
          key: index,
        }
      })
    : []

  //download feature in data table

  //columns for data table
  const columns = [
    {
      dataField: "sNo",
      text: "S.No",
    },
    {
      dataField: "leadNo",
      text: "Lead No",
      sort: true,
      formatter: (cellContent, row) => {
        const leadData = row.routeData
        return (
          <Link
            to={{
              pathname: `/client-details/${row._id}`,
              state: {
                row: leadData,
                mode: "EC",
                leadClientId: leadData,
                modeMenu: "EventCancel",
                menuName: "EventCancel",
              },
            }}
          >
            <span>{row.leadNo}</span>
          </Link>
        )
      },
      style: {
        color: "#e40d8c",
        textTransform: "uppercase",
      },
      headerStyle: {
        minWidth: "125px",
      },
    },

    {
      dataField: "companyName",
      text: "Company",
      sort: true,
      headerStyle: {
        minWidth: "140px",
      },
    },
    {
      dataField: "branchName",
      text: "Branch",
      sort: true,
      style: {
        textTransform: "uppercase",
      },
      headerStyle: {
        minWidth: "130px",
      },
    },

    {
      dataField: "clientCode",
      text: "Client Code",
      sort: true,
      style: {
        color: "#e40d8c",
        textTransform: "uppercase",
      },
      headerStyle: {
        minWidth: "130px",
      },
    },
    {
      dataField: "clientName",
      text: "Client Name ",
      sort: true,
      style: {
        textTransform: "uppercase",
      },
      headerStyle: {
        minWidth: "155px",
      },
    },
    {
      dataField: "brideName",
      text: "Bride Name ",
      sort: true,
      headerStyle: {
        minWidth: "140px",
      },
    },
    {
      dataField: "groomName",
      text: "Groom Name ",
      sort: true,
      headerStyle: {
        minWidth: "140px",
      },
    },
    {
      dataField: "cancelledDate",
      text: "Cancelled Date",
      sort: true,
      headerStyle: {
        minWidth: "165px",
      },
    },
    {
      dataField: "eventCancelByName",
      text: "Cancelled By",
      sort: true,
      headerStyle: {
        minWidth: "140px",
      },
    },
    {
      dataField: "eventCancelRemarks",
      text: "Cancelled Remarks",
      sort: true,
      headerStyle: {
        minWidth: "175px",
      },
    },
    {
      dataField: "eventCancelattachment",
      text: "Attachment",
      sort: true,
      formatter: (cellContent, row) => {
        console.log(row)
        var attachments = !isEmpty(row.eventCancelattachment)
          ? row.eventCancelattachment
          : []

        // console.log(str, "string attachments")

        return (
          <div>
            <a onClick={() => window.open(attachments, "_blank")}>
              <span
                style={{
                  textDecoration: "underline",
                  color: "#E40D8C",
                }}
              >
                View
              </span>
            </a>
          </div>
        )
      },
      headerStyle: {
        minWidth: "155px",
      },
    },
    {
      dataField: "assignedEcName",
      text: "Ec Agent Name",
      sort: true,

      headerStyle: {
        minWidth: "165px",
      },
    },
    {
      dataField: "events",
      text: "No of Events",
      sort: true,
      formatter: (cellContent, row) => {
        return (
          <div className="space-between">
            <span className="badge rounded-pill bg-primary">{row.events}</span>
          </div>
        )
      },
      headerStyle: {
        minWidth: "150px",
      },
    },

    {
      dataField: "overallStatus",
      text: "Overall Status",
      sort: true,
      style: {
        color: "#e40d8c",
      },
      headerStyle: {
        minWidth: "180px",
      },
    },
    {
      dataField: "ecAssign",
      text: "EC Status",
      sort: true,
      formatter: (cellContent, row) => {
        return (
          <>
            {row.ecProcessStatus !== "PS2" && !isEmpty(row.ecStatusName) ? (
              <button
                style={{
                  background: row.colorCode,
                  border: "none",
                  cursor: "pointer",
                  color: "white",
                  padding: "3px 6px",
                  borderRadius: "4px",
                }}
              >
                {row.ecStatusName}
              </button>
            ) : (
              "--"
            )}
          </>
        )
      },
      headerStyle: {
        minWidth: "150px",
      },
    },
  ]

  //Pagination section start //
  //Search filter
  const [searchInput, setSearchInput] = useState("")
  const [searchFilter, setSearchFilter] = useState(false)
  console.log(searchInput, "searchInput")

  const handleClick = (e) => {
    e.preventDefault()
    setSearchFilter(true)
    specificDispatch(
      eventCancelAction.loadEventCancelledList({
        searchFilter: searchInput,
        page: pageChange ? pageCount : 1,
        limit: 50,
      })
    )
    setTimeout(() => {
      setSearchFilter(false)
    }, 1200)
  }

  //Download functionality

  const downloadFile = ({ data, fileName, fileType }) => {
    const blob = new Blob([data], { type: fileType })

    const a = document.createElement("a")
    a.download = fileName
    a.href = window.URL.createObjectURL(blob)
    const clickEvt = new MouseEvent("click", {
      view: window,
      bubbles: true,
      cancelable: true,
    })
    a.dispatchEvent(clickEvt)
    a.remove()
  }

  const exportToCsv = () => {
    var searchCompany = companies && companies ? company : ""
    var searchBranch = branches && branches ? branch : ""
    var searchEvent = events && events ? events.value : ""
    var searchAgent = salesAgent && salesAgent ? salesAgent.value : ""
    var searchFromDate =
      eventData && eventData.fromDate
        ? moment(eventData.fromDate).format("YYYY-MM-DD")
        : ""
    var searchToDate =
      eventData && eventData.toDate
        ? moment(eventData.toDate).format("YYYY-MM-DD")
        : ""
    var searchLeadNo = eventData && eventData.leadNo ? eventData.leadNo : ""

    var searchvalue = {}
    searchvalue.page = pageChange ? pageCount : 1
    searchvalue.limit = 50
    // searchvalue.isManageEC = true
    if (searchCompany) {
      searchvalue.companyId = searchCompany
    }
    if (searchAgent) {
      searchvalue.employeeId = searchAgent
    }
    if (searchBranch) {
      searchvalue.branchId = searchBranch
    }
    if (searchEvent) {
      searchvalue.eventId = searchEvent
    }
    if (searchFromDate) {
      searchvalue.eventFromDate = searchFromDate
    }
    if (searchToDate) {
      searchvalue.eventToDate = searchToDate
    }
    if (searchLeadNo) {
      searchvalue.leadNo = searchLeadNo
    }
    setPageLoad(!pageLoad)

    setDownloadLoading(true)
    api
      .post(`/get_ec_cancel_status`, searchvalue)
      .then((response) => {
        console.log(response.data, "response")

        const unassignedExcelDataTable = !isEmpty(response.data.data)
          ? response.data.data.map((data, index) => {
              const cancelledDate = !isEmpty(data.completedOn)
                ? moment(data.completedOn)
                    .subtract(5, "hours")
                    .subtract(30, "minutes")
                    .format(`${dateFormate} hh:mm A`)
                : "--"

              const eventCount =
                !isEmpty(data) && data.events.length > 0
                  ? data.events.length
                  : 0

              const colorCode =
                !isEmpty(recordsMetaData) &&
                recordsMetaData.processStatusOptions &&
                recordsMetaData.processStatusOptions.length > 0 &&
                recordsMetaData.processStatusOptions.find(
                  (_) => _.processStatusId === data.ecProcessStatus
                ) &&
                recordsMetaData.processStatusOptions.find(
                  (_) => _.processStatusId === data.ecProcessStatus
                )

              return {
                _id: data._id,
                sNo: index + 1,
                leadNo: data.leadNo,
                // leadNo: data.leadNo,
                branchName: data.branchName,
                groomName: data.groomName,
                brideName: data.brideName,
                routeData: data,
                clientName: !isEmpty(data.clientDetails)
                  ? data.clientDetails.firstName +
                    " " +
                    data.clientDetails.lastName
                  : "",
                companyName: data.companyName,
                leadServiceName: data.leadServiceName,
                leadSourceName: data.leadSourceName,
                leadType: data.leadType,
                salesUrge: data.salesUrge,
                overallStatus: !isEmpty(data.overAllStatus)
                  ? data.overAllStatus
                  : "--",
                allowOrder: !isEmpty(data.allowOrder) ? data.allowOrder : "--",
                eventDetails: data.events,
                clientCode: !isEmpty(data.clientDetails)
                  ? data.clientDetails.clientNo
                  : "",
                events: eventCount,
                colorCode: colorCode.colorCode,
                ecStatusName: colorCode.label,
                ecAssign:
                  data.ecProcessStatus !== "PS2"
                    ? data.ecPrcessStatusName
                    : "--",
                assignedEcName: !isEmpty(data.leadECAssign)
                  ? data.leadECAssign.assignedToName
                  : "",
                cancelledDate: cancelledDate,
                cancelledRemarks: !isEmpty(data.cancelledRemarks)
                  ? data.cancelledRemarks
                  : "--",
                eventCancelByName: !isEmpty(data.eventCancelByName)
                  ? data.eventCancelByName
                  : "--",
                attachment: !isEmpty(data.completedAttachment)
                  ? data.completedAttachment
                  : "--",
                ecProcessStatus: data.ecProcessStatus,
                ecProcessStatusName: !isEmpty(data.ecProcessStatusName)
                  ? data.ecProcessStatusName
                  : "--",
                clearanceReport:
                  data.ecProcessStatus !== "PS2"
                    ? data.ecPrcessStatusName
                    : "--",
                leadStatus:
                  !isEmpty(data) && data.leadAssign.leadStatus === "PS2"
                    ? "Assigned"
                    : "Unassigned",
                key: index,
              }
            })
          : []
        setTimeout(() => {
          let headerData = [
            "S.No,Lead No,Company,Branch,Client Code,Client Name,Bride Name,Groom Name, Cancelled Date, Cancelled By,Cancelled Remarks,Attachment,Ec Agent Name,No of Events, Overall Status,EC Status",
          ]

          let usersCsv = !isEmpty(unassignedExcelDataTable)
            ? unassignedExcelDataTable.reduce((acc, user) => {
                const {
                  sNo,
                  leadNo,
                  companyName,
                  branchName,
                  clientCode,
                  clientName,
                  brideName,
                  groomName,
                  cancelledDate,
                  eventCancelByName,
                  cancelledRemarks,
                  attachment,
                  assignedEcName,
                  events,
                  overallStatus,
                  ecProcessStatusName,
                } = user
                acc.push([
                  sNo,
                  leadNo,
                  companyName,
                  branchName,
                  clientCode,
                  clientName,
                  brideName,
                  groomName,
                  cancelledDate,
                  eventCancelByName,
                  cancelledRemarks,
                  attachment,
                  assignedEcName,
                  events,
                  overallStatus,
                  ecProcessStatusName,
                ])

                console.log("test", acc)
                return acc
              }, [])
            : false
          console.log(usersCsv, "usersCsv")

          const usersList =
            !isEmpty(usersCsv) && usersCsv.length > 0 ? usersCsv : []

          downloadFile({
            data: [...headerData, ...usersList].join("\n"),
            fileName: "EventCancelledList.csv",
            fileType: "text/csv",
          })
          setDownloadLoading(false)
        }, 2500)
        return response.data
      })
      .catch((error) => Promise.reject(error))
  }

  const RemotePagination = ({
    data,
    page,
    // sort,
    sizePerPage,
    onTableChange,
    totalSize,
  }) => (
    <div>
      <PaginationProvider
        pagination={paginationFactory({
          custom: true,
          page,
          sizePerPage,
          totalSize,
        })}
      >
        {({ paginationProps, paginationTableProps }) => (
          <div>
            <ToolkitProvider
              keyField="_id"
              data={data}
              columns={columns}
              search
              exportCSV
            >
              {() => (
                <div>
                  <Col md="12" xl="12" lg="12" sm="12" xs="12">
                    <Row className="d-flex flex-row">
                      <Col className="mb-3" md="4"></Col>

                      <Col md="8">
                        <div
                          style={{
                            float: "right",
                          }}
                        >
                          <Button
                            className="btn btn-primary"
                            onClick={exportToCsv}
                            id="download"
                            style={{
                              backgroundColor: "#e40d8c",
                              color: "white",
                              border: "none",
                              marginBottom: "20px",
                              marginTop: "-41px",
                            }}
                          >
                            Download
                          </Button>
                        </div>
                      </Col>

                      <Col id="my-component">
                        <BootstrapTable
                          remote
                          keyField="_id"
                          data={data}
                          id="ImportTable"
                          columns={columns}
                          responsive
                          striped={true}
                          bordered={true}
                          onTableChange={onTableChange}
                          {...paginationTableProps}
                          expandRow={expandRow}
                        />
                      </Col>
                    </Row>
                    <Row
                      style={{ marginTop: "5px" }}
                      className="align-items-md-center mt-30"
                    >
                      <Col className="inner-custom-pagination d-flex">
                        <div className="d-inline d-flex flex-row">
                          <SizePerPageDropdownStandalone {...paginationProps} />
                          <div
                            style={{
                              fontSize: "14px",
                              marginTop: "8px",
                              marginLeft: "4px",
                            }}
                          >
                            <PaginationTotalStandalone {...paginationProps} />
                          </div>
                        </div>
                        <div
                          className="text-md-right ms-auto"
                          style={{ zIndex: 0 }}
                        >
                          <PaginationListStandalone {...paginationProps} />
                        </div>
                      </Col>
                    </Row>
                  </Col>
                </div>
              )}
            </ToolkitProvider>
          </div>
        )}
      </PaginationProvider>
    </div>
  )

  const [state, setState] = useState({
    sizePerPage: 50,
    page: 1,
    totalSize: event_cancelled_details.length,
    data:
      !isEmpty(event_cancelled_details) && event_cancelled_details.length > 0
        ? event_cancelled_details.slice(0, 50)
        : [],
  })
  const { sizePerPage, page } = state

  //Table Change

  const handleTableChange = (type, { page, currentIndex, sizePerPage }) => {
    setPageCount(page)
    setPageChange(true)
    setPageLoad(!pageLoad)
    console.log(page, "page")
    let result =
      !isEmpty(event_cancelled_details) && event_cancelled_details.length > 0
        ? event_cancelled_details
        : []

    var searchCompany = companies && companies ? company : ""
    var searchBranch = branches && branches ? branch : ""
    var searchEvent = events && events ? events.value : ""
    var searchAgent = salesAgent && salesAgent ? salesAgent.value : ""
    var searchFromDate =
      eventData && eventData.fromDate
        ? moment(eventData.fromDate).format("YYYY-MM-DD")
        : ""
    var searchToDate =
      eventData && eventData.toDate
        ? moment(eventData.toDate).format("YYYY-MM-DD")
        : ""
    var searchLeadNo = eventData && eventData.leadNo ? eventData.leadNo : ""

    var searchvalue = {}
    searchvalue.page = page
    searchvalue.limit = sizePerPage
    // searchvalue.isManageEC = true
    if (searchCompany) {
      searchvalue.companyId = searchCompany
    }
    if (searchAgent) {
      searchvalue.employeeId = searchAgent
    }
    if (searchBranch) {
      searchvalue.branchId = searchBranch
    }
    if (searchEvent) {
      searchvalue.eventId = searchEvent
    }
    if (searchFromDate) {
      searchvalue.eventFromDate = searchFromDate
    }
    if (searchToDate) {
      searchvalue.eventToDate = searchToDate
    }
    if (searchLeadNo) {
      searchvalue.leadNo = searchLeadNo
    }

    specificDispatch(eventCancelAction.loadEventCancelledList(searchvalue))

    setPageLoad(!pageLoad)

    setDownloadLoading(true)
    setTimeout(() => {
      setDownloadLoading(false)
    }, 1400)

    setState(() => ({
      page,
      data: result.slice(currentIndex, currentIndex + sizePerPage),
      totalSize: result.length,
      sizePerPage,
    }))
  }

  //expand row functionality from bootstrap table

  const expandRow = {
    renderer: (row) => (
      <>
        <Table bordered>
          <thead>
            <tr>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Event No
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Event Name
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Event Date
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Time
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Location
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Venue Name
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Crowd Strength
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Client Checklist
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Team Schedule
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Equipment Schedule
              </th>
            </tr>
          </thead>
          <tbody>
            {row && row.eventDetails.length > 0 ? (
              row.eventDetails.map((data) => {
                console.log(data, "row list data")

                const dateFormate =
                  !isEmpty(dateSetting) && dateSetting ? dateSetting : ""

                console.log(dateFormate, "dateFormate")
                const eventFromDate = moment(data.eventDate).format(
                  "YYYY-MM-DD"
                )
                console.log(eventFromDate, "eventFrom Date")
                const eventDate = new Date(data.eventDate)
                console.log(eventDate, "eventDate")
                if (
                  new Date(data.eventDate) >= new Date(eventData.fromDate) &&
                  new Date(data.eventDate) <= new Date(eventData.toDate)
                ) {
                  console.log(data, "expandRow data")
                  return (
                    <tr key={data._id}>
                      <th scope="data">{data.eventNo}</th>
                      <td>{data.eventName}</td>
                      <td>{moment(data.eventDate).format(dateFormate)}</td>
                      <th>{data.crewAssemblyTime}</th>
                      <td>{data.venueLocation}</td>
                      <td>{data.venueName}</td>
                      <td>{data.crowdStrength}</td>
                      <td>
                        <Badge
                          color={
                            data.ischecklistSchedule === "COMPLETED"
                              ? "success"
                              : data.ischecklistSchedule === "INPROCESS"
                              ? "warning"
                              : "danger"
                          }
                          style={{ padding: "6px", fontSize: "12px" }}
                        >
                          {" "}
                          {data.ischecklistSchedule}
                        </Badge>
                      </td>
                      <td>
                        {" "}
                        <Badge
                          color={
                            data.isTeamSchedule === "COMPLETED"
                              ? "success"
                              : data.isTeamSchedule === "INPROCESS"
                              ? "warning"
                              : "danger"
                          }
                          style={{ padding: "6px", fontSize: "12px" }}
                        >
                          {data.isTeamSchedule}
                        </Badge>
                      </td>
                      <td>
                        {" "}
                        <Badge
                          color={
                            data.isEquipmentSchedule === "COMPLETED"
                              ? "success"
                              : data.isEquipmentSchedule === "INPROCESS"
                              ? "warning"
                              : "danger"
                          }
                          style={{ padding: "6px", fontSize: "12px" }}
                        >
                          {data.isEquipmentSchedule}
                        </Badge>
                      </td>
                    </tr>
                  )
                } else if (
                  isEmpty(eventData.fromDate) &&
                  isEmpty(eventData.toDate)
                ) {
                  return (
                    <tr key={data._id}>
                      <th scope="data">{data.eventNo}</th>
                      <td>{data.eventName}</td>
                      <td>{moment(data.eventDate).format(dateFormate)}</td>
                      <th>{data.crewAssemblyTime}</th>
                      <td>{data.venueLocation}</td>
                      <td>{data.venueName}</td>
                      <td>{data.crowdStrength}</td>
                      <td>
                        <Badge
                          color={
                            data.ischecklistSchedule === "COMPLETED"
                              ? "success"
                              : data.ischecklistSchedule === "INPROCESS"
                              ? "warning"
                              : "danger"
                          }
                          style={{ padding: "6px", fontSize: "12px" }}
                        >
                          {" "}
                          {data.ischecklistSchedule}
                        </Badge>
                      </td>
                      <td>
                        {" "}
                        <Badge
                          color={
                            data.isTeamSchedule === "COMPLETED"
                              ? "success"
                              : data.isTeamSchedule === "INPROCESS"
                              ? "warning"
                              : "danger"
                          }
                          style={{ padding: "6px", fontSize: "12px" }}
                        >
                          {data.isTeamSchedule}
                        </Badge>
                      </td>
                      <td>
                        {" "}
                        <Badge
                          color={
                            data.isEquipmentSchedule === "COMPLETED"
                              ? "success"
                              : data.isEquipmentSchedule === "INPROCESS"
                              ? "warning"
                              : "danger"
                          }
                          style={{ padding: "6px", fontSize: "12px" }}
                        >
                          {data.isEquipmentSchedule}
                        </Badge>
                      </td>
                    </tr>
                  )
                }
              })
            ) : (
              <tr key={0}>
                <td className="text-align-center" colSpan={7}>
                  No data found
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </>
    ),
    showExpandColumn: true,
    expandByColumnOnly: true,
    onlyOneExpanding: true,
  }

  //get today's date
  // const current = new Date()
  // const date = `${
  //   current.getMonth() + 1
  // }-${current.getDate()}-${current.getFullYear()}`
  // console.log(date, "today date")
  //empid
  const empId = localStorage.getItem("empId")
  console.log(empId, "my employee Id")

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{title} | Zero Gravity CRM</title>
        </MetaTags>
        <Container fluid>
          <Breadcrumbs title={"Event Coordination"} breadcrumbItem={title} />

          {/*form start */}
          <Row>
            <Col xs={12}>
              <Card>
                <CardBody>
                  <form>
                    <Row>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className={"form-label"} htmlFor={"Company"}>
                            {"Company"}
                          </Label>
                        </div>

                        <Select
                          type="text"
                          name="companies"
                          isMulti
                          value={companies}
                          onChange={(e) => setCompanies(e)}
                          options={
                            recordsMetaData
                              ? recordsMetaData.companyOptions
                              : []
                          }
                          placeholder="Select Company"
                          classNamePrefix="select2-selection"
                          zIndex="2"
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className={"form-label"} htmlFor={"Branch"}>
                            {"Branch"}
                          </Label>
                        </div>
                        <Select
                          type="text"
                          name="branches"
                          isMulti
                          value={branches}
                          onChange={(e) => setBranches(e)}
                          options={branchOptions}
                          placeholder="Select Branch"
                          classNamePrefix="select2-selection"
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className={"form-label"}>{"Event"}</Label>
                        </div>
                        <Select
                          type="text"
                          name="events"
                          value={events}
                          // isMulti
                          onChange={(e) => setEvents(e)}
                          options={
                            recordsMetaData ? recordsMetaData.eventOptions : []
                          }
                          placeholder="Select event"
                          classNamePrefix="select2-selection"
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className={"form-label"}>{"EC Agent"}</Label>
                        </div>
                        <ReactSearchAutocomplete
                          name="salesAgent"
                          key={resetManager}
                          items={recordsMetaData.employeeListOptions}
                          value={salesAgent}
                          type="autoComplete"
                          resultStringKeyName="label"
                          showIcon={false}
                          onSelect={(e) => setSalesAgent(e)}
                          // onClear={reset ? true : false}
                          onChange={(e) => setSalesAgent(e.target.value)}
                          placeholder="Enter EC Agent"
                          fuseOptions={fuseOptions} // Search on both fields
                          styling={{
                            height: "34px",
                            border: "1px solid #ced4da",
                            borderRadius: "4px",
                            backgroundColor: "white",
                            boxShadow: "none",
                            hoverBackgroundColor: "#E40D8C",
                            color: "black",
                            fontSize: "12px",
                            fontFamily: "Courier",
                            iconColor: "green",
                            clearIconMargin: "3px 8px 0 0",
                            zIndex: 10,
                          }}
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label
                            className="form-label"
                            htmlFor={"Event From Date"}
                          >
                            {"Event From Date"}
                          </Label>
                        </div>
                        <Input
                          type="date"
                          placeholder="Select Date"
                          name="fromDate"
                          value={eventData.fromDate}
                          max={eventData.toDate}
                          onChange={(e) => handleChange(e)}
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label
                            className="form-label"
                            htmlFor={"Event To Date"}
                          >
                            {"Event To Date"}
                          </Label>
                        </div>
                        <Input
                          type="date"
                          placeholder="Select Date"
                          name="toDate"
                          value={eventData.toDate}
                          min={eventData.fromDate}
                          onChange={(e) => handleChange(e)}
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label
                            className="form-label"
                            htmlFor={"Event To Date"}
                          >
                            {"Lead No"}
                          </Label>
                        </div>
                        <Input
                          type="text"
                          placeholder="Enter Lead No"
                          name="leadNo"
                          value={eventData.leadNo}
                          onChange={(e) => handleChange(e)}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col lg="12" md="12" sm="12" xs="12" className="mt-3">
                        <div
                          className="filter-buttons"
                          style={{ float: "right" }}
                        >
                          <Button
                            type="button"
                            onClick={() => resetForm()}
                            className="btn btn-danger btn-label simple-form-Reset-btn"
                          >
                            <i className="bx bx-reset bx-flip-horizontal label-icon"></i>
                            Reset
                          </Button>
                          <Button
                            type="submit"
                            onClick={(e) => applyFilter(e)}
                            className="btn btn-success btn-label simple-form-applyfilter-btn mx-2"
                          >
                            <i className="bx bx-filter-alt label-icon"></i>
                            {btnLoader && btnLoader ? (
                              <ButtonSpinner />
                            ) : (
                              "Apply Filter"
                            )}{" "}
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  </form>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col md="12" lg="12" xl="12">
              <Card>
                <CardBody>
                  <div
                    className="d-flex flex-row"
                    style={{ marginTop: "20px" }}
                  >
                    <div className="search-box me-2 mb-2 d-inline-block d-flex flex-row ">
                      <form onSubmit={handleClick} className="d-flex flex-row">
                        <div style={searchBarStyle || null}>
                          <Input
                            type="text"
                            name="searchInput"
                            value={searchInput}
                            onChange={(e) => setSearchInput(e.target.value)}
                            className="form-control"
                            placeholder="Search"
                            style={{ position: "relative" }}
                          />
                          <i
                            className="bx bx-search-alt"
                            style={{
                              position: "absolute",
                              top: "54px",
                              left: "41px",
                              fontSize: "13px",
                            }}
                          />
                        </div>
                        <button
                          className="btn btn-success mx-2"
                          type="submit"
                          style={{
                            background: searchFilter ? "#2ca67a" : "",
                            color: searchFilter ? "#ffffff" : "",
                          }}
                          // onClick={(e) => handleClick()}
                        >
                          <i className="fas fa-search"></i>
                        </button>
                      </form>
                    </div>
                  </div>{" "}
                  {/* <div className="d-flex flex-row">
                    
                    
                  </div> */}
                  <RemotePagination
                    data={eventDataTable}
                    page={page}
                    sizePerPage={sizePerPage}
                    totalSize={
                      !isEmpty(event_cancelled_details)
                        ? event_cancelled_details.totalDataCount
                        : 0
                    }
                    onTableChange={handleTableChange}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
          {downloadLoading ? (
            <Modal
              show={downloadLoading}
              style={{ width: "6.7%", margin: "18% 50%" }}
            >
              <Modal.Body>
                <Spinner
                  as="span"
                  animation="grow"
                  size="lg"
                  role="status"
                  aria-hidden="true"
                  variant="success"
                  className="mx-2"
                  color="success"
                />
                {/* <span>Loading...</span> */}
              </Modal.Body>
            </Modal>
          ) : (
            ""
          )}
        </Container>
      </div>
    </React.Fragment>
  )
}

EventCancel.propTypes = {
  dispatch: PropTypes.func,
  searchProps: PropTypes.func,
  baseProps: PropTypes.any,
  searchBarStyle: PropTypes.any,
  csvProps: PropTypes.any,
  data: PropTypes.array.isRequired,
  page: PropTypes.number.isRequired,
  loading: PropTypes.bool.isRequired,
  totalSize: PropTypes.number.isRequired,
  sizePerPage: PropTypes.number.isRequired,
  onTableChange: PropTypes.func.isRequired,
  onSearch: PropTypes.func,
  onExport: PropTypes.func,
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  }
}
const mapStateToProps = () => ({
  //mapstate to props
})

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(EventCancel)
)
